import { cva } from "class-variance-authority";

export const cardVariants = cva(
  "bg-card text-card-foreground flex flex-col gap-6 rounded-lg border shadow-sm dark:shadow-md transition-colors",
  {
    variants: {
      hover: {
        true: "hover-surface-primary",
        false: "",
      },
      padding: {
        xs: "py-2",
        sm: "py-4",
        md: "py-6",
        lg: "py-8",
      },
      border: {
        plain: "border-transparent",
        // Border color lives only here (not in the base string above) so it can't
        // collide with this class at equal specificity — see card-variants.ts audit notes.
        // Matches the global --border token (bumped alongside this fix), so it stays
        // consistent with dividers/badges elsewhere that reference border-border directly.
        accent: "border-border",
      },
    },
    defaultVariants: {
      hover: false,
      padding: "md",
      border: "accent",
    },
  },
);
